import { render } from "./PaymentModal.vue?vue&type=template&id=6fae8e02&scoped=true"
import script from "./PaymentModal.vue?vue&type=script&lang=ts"
export * from "./PaymentModal.vue?vue&type=script&lang=ts"

import "./PaymentModal.vue?vue&type=style&index=0&id=6fae8e02&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6fae8e02"

export default script